import { Component, OnInit } from '@angular/core';
import { CommunicationService } from '@services/communication.service';
import { CommunicationModel } from '@models/communication-model';
import { LocalizationService } from '@services/localization.service';
import { MatDialog } from '@angular/material';
import { CommunicationPopupComponent } from '@components/communication-popup/communication-popup.component';

@Component({
  selector: 'app-communication-viewer',
  templateUrl: './communication-viewer.component.html',
  styleUrls: ['./communication-viewer.component.scss']
})
export class CommunicationViewerComponent implements OnInit {
  communications: CommunicationModel[];
  isLoading = true;

  constructor(
    private commsService: CommunicationService,
    public localeService: LocalizationService,
    private dialog: MatDialog
  ) {}

  ngOnInit() {
    this.commsService.getCommunications().subscribe(comms => {
      this.communications = comms;
      this.isLoading = false;
    });
  }

  selectCommunication(communication: CommunicationModel) {
    const ref = this.dialog.open(CommunicationPopupComponent, {
      minWidth: '500px',
      minHeight: '400px',
      maxWidth: '80vw',
      maxHeight: '80vw',
      width: '', // clear the width.. something else is setting it
      data: {
        communication
      }
    });

    ref.afterClosed().subscribe(data => {
      // this.commsService.markCommunicationRead(communication).subscribe();
    });
  }

  back() {
    window.history.back();
  }
}
